// extracted by mini-css-extract-plugin
export default {"eventsPage":"eventsPage_eventsPage__iBUEj","wrapper":"eventsPage_wrapper__HgHlE"};